import { render, staticRenderFns } from "./UserSettingsNestedPage.vue?vue&type=template&id=50fc3979"
import script from "./UserSettingsNestedPage.vue?vue&type=script&lang=js"
export * from "./UserSettingsNestedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports